import React, { useEffect } from 'react';
import { Layout, ConfigProvider } from 'antd';
import { getTheme, useTheme } from '../../resources/theme';
import ContentLayout from './layout/content-layout';
import FooterLayout from './layout/footer-layout';
import { loginLineRequest } from '../../redux/line/action';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCustomer } from '../../screens/hooks/useGetCustomer';
import { setCookies } from '../../store/useCookies';
import { setInfo } from '../../redux/info/action';
import HeaderLayout from './layout/header-layout';

const LayoutPage = () => {
  const { sidebarMode, globalTheme } = useTheme();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state?.line?.profile) || {};
  const { mutate: onCallInfo } = useGetCustomer();

  useEffect(() => {
    if (!profile.userId) dispatch(loginLineRequest());
  }, [profile]);

  useEffect(() => {
    if (profile?.userId) {
      onCallInfo(
        { userId: profile.userId },
        {
          onSuccess: (info) => {
            dispatch(setInfo(info?.result?.item));
            setCookies('accessToken', info?.result?.item?.accessToken);
          },
        },
      );
    }
  }, [dispatch, profile, onCallInfo]);

  return (
    <ConfigProvider theme={globalTheme}>
      <Layout
        className="site-layout"
        style={{
          height: '100vh',
        }}
      >
        <HeaderLayout />
        <ContentLayout getTheme={getTheme} sidebarMode={sidebarMode} />
        <FooterLayout />
      </Layout>
    </ConfigProvider>
  );
};

export default LayoutPage;
